import classNames from "classnames";
import { ReactNode } from "react";

export const errorTextClass = "bg-warning-subtle text-warning-emphasis";

export const ErrorSpan: React.FC<{ children: ReactNode; error?: boolean }> = ({ children, error = true }) => (
  <span className={classNames({ [errorTextClass]: error })}>{children}</span>
);
